(function () {
  function initFooterPreferences() {
    document.querySelectorAll('.gp-footer__newsletter-form form').forEach(function (form) {
      if (form.dataset.gpPreferencesReady === 'true') return;

      var hiddenTags = form.querySelector('input[name="contact[tags]"]');
      var interests = Array.prototype.slice.call(form.querySelectorAll('[data-gp-interest]'));
      var regions = Array.prototype.slice.call(form.querySelectorAll('[data-gp-region]'));
      var error = form.querySelector('[data-gp-preference-error]');
      var preferences = form.querySelector('[data-gp-footer-preferences]');
      var interestError = preferences ? preferences.getAttribute('data-interest-error') : '';
      var regionError = preferences ? preferences.getAttribute('data-region-error') : '';

      if (!hiddenTags || !interests.length || !regions.length) return;

      function updateTags() {
        var tags = ['prospect', 'newsletter'];

        interests.forEach(function (input) {
          if (input.checked) tags.push(input.value);
        });

        regions.forEach(function (input) {
          if (input.checked) tags.push(input.value);
        });

        hiddenTags.value = tags.join(',');
      }

      function validateInterests() {
        var hasInterest = interests.some(function (input) { return input.checked; });

        interests.forEach(function (input) {
          input.setCustomValidity('');
        });

        if (!hasInterest) {
          interests[0].setCustomValidity(interestError);
          if (error) error.textContent = interestError;
          return false;
        }

        if (error) error.textContent = '';
        return true;
      }

      function validateRegion() {
        var hasRegion = regions.some(function (input) { return input.checked; });

        regions.forEach(function (input) {
          input.setCustomValidity('');
        });

        if (!hasRegion) {
          regions[0].setCustomValidity(regionError);
          if (error) error.textContent = regionError;
          return false;
        }

        if (error) error.textContent = '';
        return true;
      }

      interests.forEach(function (input) {
        input.addEventListener('change', function () {
          validateInterests();
          updateTags();
        });
      });

      regions.forEach(function (input) {
        input.addEventListener('change', function () {
          validateRegion();
          updateTags();
        });
      });

      form.addEventListener('submit', function (event) {
        updateTags();

        if (!validateInterests()) {
          event.preventDefault();
          interests[0].reportValidity();
          return;
        }

        if (!validateRegion()) {
          event.preventDefault();
          regions[0].reportValidity();
        }
      });

      updateTags();
      form.dataset.gpPreferencesReady = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', initFooterPreferences);
  document.addEventListener('shopify:section:load', initFooterPreferences);
})();